import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Archivo } from '@models/archivo.model';
import { AlertService } from '@services/alert.service';
import { ErrorService } from '@services/error.service';
import { ExpedienteService } from '@services/expediente.service';
import { NotificacionService } from '@services/notificacion.service';
import { SessionService } from '@services/session.service';
import { StateService } from '@services/state.service';
import { BaseFuncionalidadComponent } from '@shared/base/base-funcionalidad.component';
import AccionesFuncionalidad from '@shared/enums/acciones.enum';
import TiposNotificacion from '@shared/enums/notificacion-tipos.enum';
import { DangerError, WarningError } from '@shared/errors/custom.error';

@Component({
    selector: 'app-expedientes-detalle-apelacion',
    templateUrl: './expedientes-detalle-apelacion.component.html',
    styleUrls: ['./expedientes-detalle-apelacion.component.scss']
})
export class ExpedientesDetalleApelacionComponent extends BaseFuncionalidadComponent {
    constructor(
        route: ActivatedRoute,
        sessionService: SessionService,
        location: Location,
        router: Router,
        stateService: StateService,
        private errorService: ErrorService,
        private notificacionService: NotificacionService,
        private expedienteService: ExpedienteService
    ) {
        super(route, sessionService, location, router, stateService);
    }

    isPDF: boolean; // Variable que maneja si el documento es un pdf
    urlTemporal: SafeResourceUrl;
    mostrarModalAprobacion = false; // Variable que maneja el renderizado del modal de aprobación de la apelación
    mostrarModalRechazo = false; // Variable que maneja el renderizado del modal de rechazo de la apelación
    mostrarModalConfirmacionApelacion = false; // Variable que maneja el renderizado del modal de rechazo de la apelación

    motivoRechazo: string; // variable que guarda el motivo de rechazo de la apelación
    mensajeExito: string; // variable que guarda el mensaje de exito en la acción del expediente
    documentoSeleccionado: Archivo; // Variable que guarda el documento seleccionado
    motivoApelacion: string = '';

    ngOnInit() {
        this.obtenerDocumentoApelacion();
    }

    async obtenerDocumentoApelacion() {
        if (!this.expediente.apelacion) return;
        this.isLoading = true;
        try {
            this.expediente.apelacion.archivo = await this.expedienteService.obtenerDocumentoApelacion(this.id);
        } catch (error) {
            this.errorService.handle(error, "Error al obtener la información del documento.");
        } finally {
            this.isLoading = false;
        }
    }

    abrirModal(accion: number) {
        this.motivoRechazo = "";
        this.mensajeExito = "";

        try {
            switch (accion) {
                case AccionesFuncionalidad.aprobar_apelacion:
                    if (!this.canApproveApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
                    this.mostrarModalAprobacion = true;
                    break;
                case AccionesFuncionalidad.rechazar_apelacion:
                    if (!this.canRejectApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
                    this.mostrarModalRechazo = true;
                    break;
                case AccionesFuncionalidad.solicitar_apelacion:
                    if (!this.canMakeApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
                    this.mostrarModalConfirmacionApelacion = true;
                    break;
            }
        } catch (error) {
            this.errorService.handle(error, "Error al abrir el modal.");
        }
    }

    onModalConfirmacionCerrado() {
        this.mostrarModalConfirmacion = false;
        this.volverDosPaginasAtras(); // Vuelve atras al cerrar el modal de confirmación
    }

    async aprobarApelacion() {
        this.isLoadingModal = true;
         const archivo: Archivo = new Archivo();
        try {
            if (!this.canApproveApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
            /* const msg = await this.notificacionService.generarNotificacion(this.expediente.id, TiposNotificacion.solicitud_antecedentes); */ // TODO: Cambiar tipo de notificación
            //this.mensajeExito = await this.expedienteService.aprobarApelacionExpediente(this.expediente.id,archivo, this.motivoRechazo.trim());
            this.mostrarModalAprobacion = false;
            if (this.mensajeExito) this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
        } catch (error) {
            this.errorService.handle(error, "Error al aprobar la apelación del expediente.");
        } finally {
            this.isLoadingModal = false;
        }
    }

    async rechazarApelacion() {
        this.isLoadingModal = true;
        const archivo: Archivo = new Archivo();
        try {
            if (!this.canRejectApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
            if (!this.motivoRechazo) throw new WarningError("Debe ingresar un motivo por el cual esta rechazando el expediente");
            // TODO: Agregar envío de notificación
            this.mensajeExito =
                await this.expedienteService.rechazarApelacionExpediente(
                    this.expediente.id,
                    archivo,
                    this.motivoRechazo
                );
            this.mostrarModalRechazo = false;
            this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
        } catch (error) {
            this.errorService.handle(error, "Error al rechazar la apelación del expediente.");
        } finally {
            this.isLoadingModal = false;
        }
    }

    // Prestador: enviar apelación
    async enviarApelacion() {
        this.isLoadingModal = true;
        try {
            if (!this.canMakeApelation) throw new DangerError("No tiene permisos para ejecutar esta acción");
            this.mensajeExito = await this.expedienteService.enviarApelacionExpediente(this.expediente.id);
            this.mostrarModalConfirmacionApelacion = false;
            this.mostrarModalConfirmacion = true; // Encadena el modal de confirmación tras aceptar
        } catch (error) {
            this.errorService.handle(error, "Error al aprobar la apelación del expediente.");
        } finally {
            this.isLoadingModal = false;
        }
    }

    asignarDocumento(file: Archivo) {
        this.documentoSeleccionado = file;
    }
    obtenerUrlTemporal(url: SafeResourceUrl) {
        this.urlTemporal = url;
    }
}
